function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Radiator"
}, /*#__PURE__*/React.createElement("title", null, "VF_radiator_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M28.8 184.2H0v28.4h28.8v28.3h27.4V42.5H28.8zM78.4 42.5h27.4v198.4H78.4zM128 42.5h27.4v198.4H128zM177.6 42.5H205v198.4h-27.4zM283.5 70.9h-28.8V42.5h-27.4v198.4h27.4V99.2h28.8z"
}))));